import { FilterCountService } from './../../services/filter-count/filter-count.service';
import { DataTable } from './../../interfaces/datatable.interface';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-datatable-filtro-magico',
  templateUrl: './datatable-filtro-magico.component.html',
  styleUrls: ['./datatable-filtro-magico.component.scss']
})
export class DatatableFiltroMagicoComponent implements OnInit {

  @Input() id: string;
  @Input() datatable: DataTable;

  @Output() onFiltrosCambiados = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Output() onBotonFiltrarPresionado = new EventEmitter<any>();
  filtrosModal = {};

  cantidadFiltrosSeleccionados = 0;

  constructor(private filterCountService: FilterCountService) {}

  ngOnInit(): void {
    this.datatable.filtrosMagicos.mostrarBotonFiltrar = false;
  }

  filtrosCambiados(filtros) {
    this.recalcularCantidadFiltrosSeleccionados(filtros);
    this.filtrosModal = filtros;
    this.onFiltrosCambiados.emit(filtros);
  }

  onBotonFiltrar() {
    this.onBotonFiltrarPresionado.emit(this.filtrosModal);
  }

  close() {
    this.onClose.emit(this.filtrosModal);
  }

  recalcularCantidadFiltrosSeleccionados(filtros) {
    this.cantidadFiltrosSeleccionados = this.filterCountService.contarFiltros(filtros);
  }

}
